/* eslint no-mixed-operators: 0 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CargomaticModal from 'components/v2/modal';
import _ from 'underscore';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import Dropzone from 'react-dropzone';
import { ACCEPTED_FILE_TYPES } from 'config/accepted-file-types';
import { Glyphicon, Tooltip, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import ViewAccessorialRequestDocumentRequirements from 'components/modules/shipments/accessorials/ViewAccessorialDocumentRequirements';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import DocumentPreview from './stops/DocumentPreview';
class DocumentUpload extends Component {
    constructor(props) {
        super(props);
        this.upload = () => {
            const { accessorial, accessorial: { id }, onHide, t, } = this.props;
            const name = t('ACCESSORIAL_DOC_NAME', {
                accessorialName: accessorial.accessorial,
            });
            ShipmentsActionCreators.uploadAccessorialDocument(id, this.state.files, name, this.state.notes, accessorial.accessorial);
            onHide();
        };
        this.handleFile = (file) => {
            this.setState((previousState) => {
                return {
                    files: [...previousState.files, ...file],
                };
            });
        };
        this.handleRemoveFile = (id) => {
            const { files } = this.state;
            const newFiles = _.without(files, _.findWhere(files, { preview: id }));
            this.setState({ files: newFiles });
        };
        this.handleNoteChange = (e) => {
            this.setState({ notes: e.target.value });
        };
        this.state = {
            files: [],
            notes: '',
        };
    }
    renderPreview() {
        if (!this.state.files.length) {
            return null;
        }
        const filePreviews = this.state.files.map((file, index) => {
            return (React.createElement("div", { key: index, className: "px-4 py-2" },
                React.createElement(DocumentPreview, { url: file.preview, type: file.type, displayInGridView: true, renderDownloadableImage: true, handleRemove: this.handleRemoveFile })));
        });
        return (React.createElement("div", null,
            React.createElement(Row, null,
                React.createElement("div", { className: "grid-3-x-3" }, filePreviews)),
            React.createElement("hr", null)));
    }
    renderUploader() {
        var _a;
        const { t, shipment, accessorial } = this.props;
        if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ViewAccessorialRequestDocumentRequirements, { containerClassName: "mb-4 p-2", accessorial: Object.assign(Object.assign({}, accessorial), { slug: accessorial.accessorial_type }), shipper: (_a = shipment === null || shipment === void 0 ? void 0 : shipment.shipper) === null || _a === void 0 ? void 0 : _a._id, shipment: shipment, isExistingAccessorialRequest: true })));
        }
        return (React.createElement("div", null,
            React.createElement("div", null, this.state.files.length ? this.renderPreview() : null),
            React.createElement(Dropzone, { style: {
                    width: '100%',
                    height: 100,
                    padding: 10,
                    borderWidth: 2,
                    borderColor: '#337ab7',
                    borderStyle: 'dashed',
                    borderRadius: 5,
                }, onDrop: this.handleFile, multiple: true, accept: ACCEPTED_FILE_TYPES },
                React.createElement("div", null, t('CLICK_OR_DRAG_TO_UPLOAD_FILE')))));
    }
    renderBody() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement("div", null, this.renderUploader()),
            React.createElement("div", { className: "mt-3" },
                React.createElement("label", { className: "form-label" }, t('NOTE', { count: 2 })),
                React.createElement("div", { className: "flex" },
                    React.createElement("textarea", { rows: "4", className: "form-field resize-none w-full", value: this.state.notes, onChange: this.handleNoteChange })))));
    }
    renderFooter() {
        const { t, onHide } = this.props;
        if (featureEnabled(CONFIGURED_FEATURES.SSR)) {
            return (React.createElement("div", { className: "flex justify-end" },
                React.createElement("button", { className: "button button-green carrier-admin-attachDocument heap", onClick: onHide }, t('CLOSE'))));
        }
        return (React.createElement("div", { className: "flex justify-end" },
            React.createElement("button", { className: "button button-green carrier-admin-attachDocument heap", onClick: this.upload, disabled: !this.state.files.length }, t('UPLOAD'))));
    }
    render() {
        const { show, onHide, accessorial, t } = this.props;
        return (React.createElement(CargomaticModal, { show: show, onHide: onHide, body: this.renderBody(), title: `${t('ADD_ACCESSORIAL_DOCUMENTS')} - ${accessorial.accessorial}`, footer: this.renderFooter() }));
    }
}
DocumentUpload.propTypes = {
    show: PropTypes.bool,
    accessorial: PropTypes.object,
    onHide: PropTypes.func,
};
DocumentUpload.defaultProps = {
    show: false,
    accessorial: {},
    onHide: () => {
        return null;
    },
};
export default withTranslation()(DocumentUpload);
